/** Mirror of backend/api.php late-remarks logic for display & exports */

function parseTimePartToSeconds(timeStr) {
  const raw = String(timeStr || '').trim();
  if (!raw) return null;

  const match = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (match) {
    const hour = parseInt(match[1], 10);
    const minute = parseInt(match[2], 10);
    const second = parseInt(match[3] || '0', 10);
    if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
      return hour * 3600 + minute * 60 + second;
    }
  }
  return null;
}

function normalizeShiftString(shift) {
  return String(shift || '')
    .trim()
    .replace(/[\u2013\u2014\u2212]/g, '-');
}

export function parseShiftRange(shift) {
  const normalized = normalizeShiftString(shift);
  if (!normalized || !normalized.includes('-')) return [null, null];
  const parts = normalized.split(/\s*-\s*/);
  return [
    parseTimePartToSeconds(parts[0] || ''),
    parseTimePartToSeconds(parts[1] || ''),
  ];
}

export function clockInSecondsFromTime(timeValue) {
  if (!timeValue) return null;
  const parts = String(timeValue).split(':');
  if (parts.length < 2) return null;
  const hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);
  const second = parseInt(parts[2] || '0', 10);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
  return hour * 3600 + minute * 60 + second;
}

export function isLateClockIn(clockInSeconds, shiftStartSeconds, shiftEndSeconds) {
  if (clockInSeconds === null || shiftStartSeconds === null) return false;

  const crossesMidnight = shiftEndSeconds !== null && shiftEndSeconds <= shiftStartSeconds;

  if (crossesMidnight) {
    if (clockInSeconds > shiftStartSeconds) return true;
    if (shiftEndSeconds !== null && clockInSeconds < shiftEndSeconds) return true;
    return false;
  }

  const earlyMorningStart = shiftStartSeconds < 6 * 3600;
  if (earlyMorningStart && clockInSeconds >= 18 * 3600) return false;

  return clockInSeconds > shiftStartSeconds;
}

export function getClockInRemarks(shift, timeIn) {
  const [shiftStartSeconds, shiftEndSeconds] = parseShiftRange(shift);
  const timeInSeconds = clockInSecondsFromTime(timeIn);
  if (shiftStartSeconds === null || timeInSeconds === null) return '';
  return isLateClockIn(timeInSeconds, shiftStartSeconds, shiftEndSeconds) ? 'LATE' : '';
}

/** Use stored remarks after logout; recompute at time-in while still on duty */
export function getAttendanceRemarks(log, employee) {
  const stored = String(log?.remarks || '').trim();
  const isOnDuty = !log?.timeOut || log.timeOut === '' || log.timeOut === '--:--';

  if (!isOnDuty) {
    return stored;
  }

  if (!employee?.shift || !log?.timeIn) {
    return stored;
  }

  return getClockInRemarks(employee.shift, log.timeIn);
}
